<template>
    <li v-if="!!virtualReminder">
        {{ virtualReminder.delay }} minutes {{ $t('coupon.virtualReminder') }}
    </li>
</template>

<script>
import { mapGetters } from 'vuex';
import { ConfigurationMessageEnum } from '@/enums';

export default {
    name: 'coupon-virtual-reminder',
    props: {
        appointment: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            getSelectedServiceConfigurationMessageById: 'services/getSelectedServiceConfigurationMessageById',
        }),

        /**
         * Returns the virtual-appointment-reminder EST_Configuration_Message Object | Undefined
         */
        virtualReminder() {
            return this.getSelectedServiceConfigurationMessageById(ConfigurationMessageEnum.VIRTUAL_APPOINTMENT_REMINDER);
        },
    },
};
</script>
